import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS_QUERY_KEY } from '../queries/useGetEffectiveTeamSchedulingSettings';
import { GET_TEAM_SCHEDULING_SETTINGS_QUERY_KEY } from '../queries/useGetTeamSchedulingSettings';
import type { TeamSchedulingSettingsInput } from '../../api/queries';

const invalidateTeamSchedulingCache = (
  queryClient: ReturnType<typeof useQueryClient>,
  teamId: number,
): void => {
  queryClient.invalidateQueries({
    queryKey: [GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS_QUERY_KEY, teamId],
  });
  queryClient.invalidateQueries({
    queryKey: [GET_TEAM_SCHEDULING_SETTINGS_QUERY_KEY, teamId],
  });
};

export const useUpdateTeamSchedulingSettingsMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  const { updateTeamSchedulingSettings } = useServicesContext();

  return useMutation({
    mutationKey: ['UPDATE_TEAM_SCHEDULING_SETTINGS', teamId],
    mutationFn: (settings: TeamSchedulingSettingsInput) =>
      updateTeamSchedulingSettings(teamId, settings),
    onSuccess: () => invalidateTeamSchedulingCache(queryClient, teamId),
  });
};
